import Joi from 'joi';

import { optionalString } from '../../../../../../utils/validators';
import { FormValues } from './types';

export const validationSchema = Joi.object<FormValues, true>({
  title: optionalString,
});
